export default __webpack_public_path__ + "static/grab-8a195211149b89255406fd24bf7b810b.png";